import type { IStorefrontClientConfig } from "/npm/@brytdesigns/shopify-utils@1.2.10/dist/jsdelivr/effect/Ajax/Window/data/types.js";

import * as Data from "/npm/effect@3.14.1/Data/+esm";

export class StorefrontClientConfig extends Data.Class<IStorefrontClientConfig> {
  constructor() {
    super({
      ...window.BrytDesigns.storefront.config,
    });
  }
}

export const make = () =>
  Data.case<StorefrontClientConfig>()({
    ...window.BrytDesigns.storefront.config,
  });
